import React from "react";
import { useLocation } from "react-router-dom";
import LegacyLobbyPage from "./LobbyPage";
import V2LobbyPage from "./LobbyPage.jsx";
import { isLobbyV2Path } from "../../universal/v2Routes";

export default function LobbyPageByRoute(props) {
    const location = useLocation();
    const LobbyPageComponent = isLobbyV2Path(location.pathname)
        ? V2LobbyPage
        : LegacyLobbyPage;
    return <LobbyPageComponent {...props} />;
}
